/* eslint-disable */
import {
  Button,
  DatePicker,
  Flex,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Tooltip,
  message,
} from "antd";
import React, { forwardRef, useEffect, useState,useRef } from "react";
import {
  BookOutlined,
  DeleteFilled,
  ExclamationCircleFilled,
  FormOutlined,
  PrinterFilled,
  SendOutlined,
  HomeOutlined,
  MailOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import moment from "moment";
import http from "@/utils/http";
import api from "@/utils/api";
import { checkApproveRouteDict } from "@/utils/dict";
import commonFn from "@/utils/commonFn";
import CashierCheckModal from "./CashierCheckModal"; 
const ButtonList = forwardRef((props, ref) => {
  const { selectedList, email, transactionsType, moduleType, monthlyWorkerPayId, selectedAmount } = props;
  const [modelType, setModelType] = useState(null);
  const [openRecordModal,setOpenRecordModal]= useState(false);
  const [openDownloadModal, setOpenDownloadModal]= useState(false);
  const [blodState, setBlodState]= useState(null);
  const [modalState, setModalState] = useState({});
  const [recordForm] = Form.useForm();
  const [confirmLoading, setConfirmLoading]= useState(false);
  const [btnList, setBtnList] = useState([]);
  const [currentDate, setCurrentDate]= useState(null);
  const [nextDate, setNextDate]= useState(null);
  const [defaultList, setDefaultList] = useState(['util_payment', 'maintenance_contractor', 'businessLicense', 'major_project', 'managementfee', 'maintenance_material_ap', 'pending_check', 'new_insurance']);
  const cashierRef = useRef();
  const btnListFn = (pendingFlag = false, approvedFlag =false) => {
     setBtnList([
      {
        title: "Send Check For Approval From Upper Managements",
        name: "Request For Approval",
        typeColor: "#00a65a",
        type: 1,
        authKey: 'RequestForApproval',
        disabled: !pendingFlag
      },
      {
        title:
          "Print Cashier Check Or Check Grouping By Each Transaction,Vendor,Property,Or Trust",
        name: "Print Check",
        typeColor: "#4096ff",
        type: 2,
        authKey: 'PrintCheck',
        disabled: !approvedFlag
      },
      {
        title:
          "Print Cashier Check Or Grouping By Each Transaction,Vendor,Property,Or Trust",
        name: "Print Cashier Check",
        typeColor: "#4096ff",
        type: 3,
        authKey: 'PrintCashierCheck',
         disabled: !approvedFlag
      },
      {
        title: "Booking/Posting Transactions Only",
        name: "Record Only",
        typeColor: "#4096ff",
        type: 4,
        authKey: 'RecordOnly',
        disabled: !approvedFlag
      },
      {
        title: "Delete Transaction",
        name: "Delete",
        typeColor: "#ff4d4f",
        type: 5,
        authKey: 'Delete',
      },
      // {
      //   title: "View All The Requests For Approval",
      //   name: "Approval Request",
      //   typeColor: '#4096ff',
      //   type: 6
      // },
    ]);
  }
    
  const typeMatch = {
    1: {
      title: "APPROVAL REQUEST CONFIRMATION",
      subTitleAlign: "left",
      subTitle: `Are you sure you want to request these checks to be approved?`,
      firstName: "transactionCount",
      firstLabel: "How Many Transactions?",
      firstSelectOption: [
        {
          value: "1",
          label: `Request ${selectedList.length} Transaction(s) to be Approved.`,
        },
        // { value: "2", label: "Print all approved transactions" }
      ],
      secondName: "remark",
      secondLabel: "Note For Mike:",
      secondType: 'Input',
      secondPlaceholder: 'Message or Note to Mike',
      fourName: "isSend",
      fourLabel: 'ls Email',
      fourSelectOption: [
        {
          value: 1,
          label: "Yes",
        },
        // {
        //   value: 0,
        //   label: "No",
        // },
      ],
    },
    2: {
      title: "PRINT CHECK CONFIRMATION",
      subTitleAlign: "center",
      subTitle: `System Limited to 500 rows of Approved Records, 
     Please select below items`,
      firstName: "transactionCount",
      firstLabel: "How Many Transactions?",
      firstSelectOption: [
        ...(selectedList.length ? [{
          value: "1",
          label: `To Print selected ${selectedList.length} Transaction(s).`,
        }] : []),
        ...(commonFn.btnAuthorityFlag('PrintAll') ? [{
          value: "2",
          label: "Print all approved transactions." 
        }] : [])
      ]?.filter(Boolean),
      secondName: "printBy",
      secondLabel: "Print By:",
      secondSelectOption: [
        // util_payment  transaction
        // maintenance_contractor  prop + transaction + vendid + vendor
        // businessLicense  transaction
        // major_project  prop + transaction
        // managementfee  prop + transaction + trust + vendor + customer_account
        // maintenance_material_ap  prop + transaction + trust + vendor + customer_account
        // pending_check prop + transaction + trust + vendid + vendor
        // new_insurance vpba + pvp
        // default prop + transaction + trust + customer_account
        (["maintenance_contractor", "major_project", "managementfee", "maintenance_material_ap", "pending_check"].includes(moduleType) || !defaultList.includes(moduleType)) && {
          value: "prop",
          label:
            "Property – Grouped, Print order is Prop# Smallest to Largest.",
        },
        (['util_payment', 'maintenance_contractor', 'businessLicense', 'major_project', 'managementfee', 'maintenance_material_ap', 'pending_check',].includes(moduleType) || !defaultList.includes(moduleType)) && {
          value: "transaction",
          label:
            "Transaction – Print order is Created Date and Time, Oldest to Newest.",
        },
        (["managementfee", "maintenance_material_ap", "pending_check"].includes(moduleType) || !defaultList.includes(moduleType)) && {
          value: "trust",
          label: "Trust – Grouped, Print order is Trust Name A-Z.",
        },
        (["maintenance_contractor", "pending_check",].includes(moduleType)) && {
          value: "vendid",
          label: "Vendor – Grouped, Print order is Vendor Name A-Z.",
        },
        (["maintenance_contractor", "managementfee", "maintenance_material_ap", "pending_check"].includes(moduleType)) && {
          value: "vendor",
          label:  "Vendor - No Limit In One Check.",
        },
        (["managementfee", "maintenance_material_ap"].includes(moduleType) || !defaultList.includes(moduleType)) && {
          value: "customer_account",
          label: "Customer # – Grouped, Print order is Customer # A-Z.",
        },
        (["new_insurance"].includes(moduleType)) && {
          value: "vpba",
          label: "Vendor & Policy & Bank Acct - Print order is Prop# Smallest to Largest.",
        },
        (["new_insurance"].includes(moduleType)) && {
          value: "pvp",
          label: "Prop & Vendor & Policy - Print order is Gl Account Smallest to Largest.",
        },
      ].filter(Boolean),
      thirdName: "postedDate",
      thirdLabel: "Print/Post Date",
      thirdDisbale: !commonFn.btnAuthorityFlag('ChangePrintPostDate'),
    },
    4: {
      title: "RECORD CHECK CONFIRMATION",
      subTitleAlign: "left",
      subTitle: `Are you sure you want to record these check(s)?`,
      firstName: "transactionCount",
      firstLabel: "How Many Transactions?",
      firstSelectOption: [
        {
          value: "1",
          label: `Request ${selectedList.length} Transaction(s) to be Recorded.`,
        },
        // { value: "2", label: "Record All Checks" }
      ],
      secondName: "printBy",
      secondLabel: "Record By:",
      secondSelectOption: [
        { value: "Property", label: "Property" },
        { value: "Transaction", label: "Transaction" },
        { value: "Trust", label: "Trust" },
        { value: "Vendor Code", label: "Vendor Code" },
        { value: "Invoice", label: "Invoice" },
      ],
      thirdName: "postedDate",
      thirdLabel: "Post Date",
      thirdDisbale: false,
    },
  };

  const typeChangeModal = async(type) => {
    let postedDate
    if (!selectedList.length && (!commonFn.btnAuthorityFlag('PrintAll') ? true : ![2].includes(type))) {
      message.warning("Please select at least one item.");
      return;
    }
    setModalState(typeMatch[type]);
    setOpenRecordModal(true);
    if([2, 4].includes(type)){
      setConfirmLoading(true)
      const cDate = await http.get(api.commonCurrentDate)
      postedDate = dayjs(cDate)
      setCurrentDate(postedDate)
      const nDate = await http.get(api.commonNextDate)
      setNextDate(dayjs(nDate))
      setConfirmLoading(false)
    }
    const printByMatch = {
      "util_payment": "transaction",
      "businessLicense": "transaction",
      "major_project": "transaction",
      "new_insurance": "vpba",
    }
    recordForm.setFieldsValue({
      isSend:  type === 1 ? 1 : undefined,
      transactionCount:  typeMatch[type].firstSelectOption[0]?.value,
      printBy: type === 2 ? (printByMatch[moduleType] ?? "prop") : 'Property' ,
      postedDate, // 默认当天日期
    });
  };

  const btnTypeFn = (type) => {
    setModelType(type);
    switch (type) {
      case 1:
      case 2:
      case 4:
        typeChangeModal(type);
        break;
      case 3:
        cashierRef.current?.open();
        break;
      case 5:
        deleteFn()
          break;
      default:
        break;
    }
  };

  const handleRecordSubmit = async () => {
    setConfirmLoading(true)
    const values = await recordForm.validateFields();
    const postedDate = values.postedDate?.format('YYYY-MM-DD')
    const ids = (selectedList || []).map(item => item.vendorPaymentId)
    const requestMatch = {
      1: {
        vendorPaymentIds: ids,
        isSend: values.isSend,
        remark: values.remark,
        type: moduleType,
        route: checkApproveRouteDict[moduleType] || checkApproveRouteDict['default']
      },
      2: {
        email,
        transactionsType,
        moduleType,
        // monthlyWorkerPayId: moduleType === 'maintenance_monthly_worker' ? monthlyWorkerPayId : undefined,
        vendorPaymentIds: ids,
        postedDate,
        printBy: values.printBy || "prop",
        transactionCount: values.transactionCount,
      },
      4: {
        ids,
        postedDate,
        printBy: values.printBy || "Property", 
      },
    }

    const apiMatch = {
      1: api.requestApproval,
      2: api.getApprovalPrintCheck,
      4: api.getApprovalRequestRecore,
    }

    const response = await http.post(apiMatch[modelType], requestMatch[modelType]);
    const name = btnList.find(item => item.type === modelType)?.name || ''
    if(response.code === '1'){
      if(modelType === 2){
        if(response.data.type === '1'){
          setBlodState(response.data)
          setOpenDownloadModal(true)
        }else{
          Modal.confirm({
            title: null,
            // icon: <ExclamationCircleOutlined />,
            content: response.data.name,
            footer: null,
            closable: true,
            maskClosable: true,
          });
        }
      }else{
        message.success(`${name} Success.`);
      }
      setOpenRecordModal(false)
      recordForm.resetFields()
      props.refreshTableFn();
    }else{
      commonFn.modalFailedFn(response)
    }
    setConfirmLoading(false)
  };

  const openLargeBase64InNewTab = async() => {
    const { url, name, isUrl } = blodState
    const tab = window.open('about:blank', '_blank');
    // const tab = window.open(window.location.origin + `#/AccountPayable/PDFViewer?file=${encodeURIComponent(url)}`, '_blank', "noopener,noreferrer");
    if(name?.split('.')?.pop()?.toLowerCase() !== 'pdf'){
      tab.document.body.textContent = 'Not a PDF, cannot embed preview';
      return;
    }
    tab.document.title = name;
    tab.location.href = isUrl? url : URL.createObjectURL(await (await fetch(url)).blob());;
    // tab.location.href = isUrl? `${url}#toolbar=0` : `${URL.createObjectURL(await (await fetch(url)).blob())}#toolbar=0`;;
    // tab.location.href = isUrl? url : URL.createObjectURL(await (await fetch(url)).blob());;
    const t = setInterval(() => {
      if (tab.closed) { URL.revokeObjectURL(url); clearInterval(t); }
    }, 1500);
  }


  //删除接口
  const delfun = async () => {
    const ids = selectedList.map(item => item.vendorPaymentId )
    const response = await http.post(`${api.ApprovalDel}`, {ids});
    if(response.code === '1'){
      message.success("Successfully Deleted");
      props.refreshTableFn();
    }
  };

  const deleteFn = () => {
    if (selectedList.length) {
      Modal.confirm({
        title: "Delete Reminder",
        icon: <ExclamationCircleOutlined />,
        content: "Are you sure you want to delete the selected data?",
        okText: "Sure",
        cancelText: "Cancel",
        onOk() {
          //确认删除
          delfun();
        },
        onCancel() {
          console.log("Cancel");
        },
        style: {
          top: "40%",
        },
      });
    } else {
      message.warning("Please select the data to delete first."); //请先选择要删除的数据
    }
  };

  useEffect(()=> {
    const pendingFlag = selectedList.every(item => ['Pending Submission', 'Rejected'].includes(item.approve))
    const approvedFlag = transactionsType !== "2" ? false : selectedList.every(item => item.approve === 'Approved')
    btnListFn(pendingFlag, approvedFlag)
  }, [selectedList])

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft">
          <Space size="small">
            {btnList.map((item) => (
              <commonFn.BtnAuthorityFn authKey={item.authKey}>
                <Tooltip placement="topLeft" title={item.title}>
                  <Button
                    style={{
                      backgroundColor: item.disabled ? 'rgba(0,0,0,0.04)' : item.typeColor,
                      borderColor: item.disabled ? '#d9d9d9' : item.typeColor,
                      color: item.disabled ? 'rgba(0,0,0,0.25)' : "white",
                      marginRight: "10px",
                    }}
                    disabled={item.disabled}
                    onClick={() => btnTypeFn(item.type)}
                  >
                    {(item.type === 1 && <SendOutlined rotate="-35" />) || null}
                    {((item.type === 2 || item.type === 3) && (
                      <PrinterFilled />
                    )) ||
                      null}
                    {(item.type === 4 && <FormOutlined />) || null}
                    {(item.type === 5 && <DeleteFilled />) || null}
                    {(item.type === 6 && (
                      <ExclamationCircleFilled twoToneColor="['#f7d80f','#f7d80f']" />
                    )) ||
                      null}
                    {item.name}
                    <span className="num" style={{ color: item.typeColor }}>
                      {selectedList.length || 0}
                    </span>
                  </Button>
                </Tooltip>
              </commonFn.BtnAuthorityFn>
            ))}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnGreen" style={{cursor: 'text'}}>
              Selected Amount: &nbsp;
              {commonFn.amountToDollarFn(selectedList?.reduce((acc, row) => {
                  return (acc * 100 + (row[selectedAmount ?? 'amount'] || 0) * 100) / 100;
                }, 0) || 0)}
            </Button> || null}
          </Space>
        </div>
      </Flex>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            { modalState.title }
            <div style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}></div>
          </div>
        }
        centered
        open={openRecordModal}
        onCancel={() => {
          setOpenRecordModal(false);
          recordForm.resetFields();
        }}
        confirmLoading={confirmLoading}
        onOk={handleRecordSubmit}
        width="50%"
        maskClosable={false}
      >
        <Form form={recordForm} layout="vertical" >
            <div style={{ marginBottom: "16px",whiteSpace: 'pre-wrap', fontSize: "20px", textAlign: modalState.subTitleAlign }}>
              { modalState.subTitle }
          </div>
            <Form.Item
              name={modalState.firstName}
              label={modalState.firstLabel}
              rules={[{ required: true }]}
              style={{ flex: 1 }}
            >
              <Select
                placeholder="Select option"
                options={modalState.firstSelectOption}
              />
            </Form.Item>

            <Form.Item
              name={modalState.secondName}
              label={modalState.secondLabel}
              // rules={[{ required: true }]}
              style={{ flex: 1 }}
            >
              {
                modalState.secondType === 'Input' ?
                <Input placeholder={modalState.secondPlaceholder || "Enter your note here"} /> :
                <Select
                  placeholder={ modalState.secondPlaceholder || "Select option"}
                  options={modalState.secondSelectOption}
                />
              }
            </Form.Item>

            {modalState.thirdName && <Form.Item
              name={modalState.thirdName}
              label={modalState.thirdLabel}
              rules={[{ required: true, message: 'Please select a date' }]}
            >
              <DatePicker
                disabled={modalState.thirdDisbale}
                disabledDate={(cur) => cur && cur > nextDate }
                style={{ width: '100%' }}
                format="MM/DD/YYYY"
                getPopupContainer={trigger => trigger.parentElement} 
              />
            </Form.Item> || null}

            {modalState.fourName && <Form.Item
              name={modalState.fourName}
              label={modalState.fourLabel}
              rules={[{ required: true }]}
              style={{ flex: 1 }}
            >
              <Select
                placeholder="Select option"
                options={modalState.fourSelectOption}
              />
            </Form.Item> || null}
        </Form>
      </Modal>
      
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <DownloadOutlined style={{ marginRight: "8px" }} />
            DOWNLOAD
            <div style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}></div>
          </div>
        }
        centered
        open={openDownloadModal}
        footer={[
          <div style={{textAlign: 'right', marginTop: 10}}>
            <Button onClick={ () => setOpenDownloadModal(false)}>
              Close
            </Button>
          </div>
        ]}
        onCancel={() => setOpenDownloadModal(false)}
        confirmLoading={confirmLoading}
        width="50%"
        maskClosable={false}
      >
        <Button type="link" onClick={ () => openLargeBase64InNewTab()}>
            Your export file is ready, Please click the link here to download it
        </Button>
      </Modal>

  <CashierCheckModal
     ref={cashierRef}
     selectedList={selectedList}
     onSuccess={() => props.refreshTableFn()}
   />
    </div>
  );
});
export default ButtonList;
